import type { GameClient, ToastNotice } from '../useGameClient';
import { Highlight } from './Names';

export function Notices({
  notices,
  client,
  showDebug,
}: {
  notices: ToastNotice[];
  client: GameClient;
  /** Show `debug` notices (bot reasoning); they are dropped otherwise. */
  showDebug: boolean;
}) {
  const names = [...(client.view?.players.map((p) => p.name) ?? []), client.me?.displayName];
  return (
    <div className="notices" role="status" aria-live="polite">
      {notices
        .filter((n) => n.kind !== 'debug' || showDebug)
        .map((n) => (
          <div key={n.id} className={`notice ${n.kind}`}>
            <Highlight text={n.text} names={names} />
          </div>
        ))}
    </div>
  );
}
